<div class="content-loaf">
  <div class="col-12">
    <h2>医療機関一覧</h2>
  </div>
  <hr />
  <div class="row">
    <div class="col-lg-6">
      <p class="info-txt">
        　自施設の状況を入力する場合<br />
        <span>自施設名をクリックし、施設状況を入力してください。</span><br />
      </p>
    </div>

    <div class="col-lg-6">
      <div class="search-box">
        <span>佐伯地区医師会 全施設状況の絞り込み検索</span><br />
        項目にチェックを入れ、検索ボタンをクリック<br />
        <div class="search-panel">
          <input type="checkbox" [(ngModel)]="consultation" /><label for="consultation">：診療</label>
          <input type="checkbox" [(ngModel)]="electricity" /><label for="electricity">：電気</label>
          <input type="checkbox" [(ngModel)]="waterSupply" /><label for="waterSupply">：水道</label>
          <input type="checkbox" [(ngModel)]="phone" /><label for="phone">：電話</label><br class="d-md-none d-lg-none" />
          <button type="button" name="search" class="btn btn-primary btn-primary-gradient" (click)="search()">検　索</button>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="table-responsive">
        <table class="table table-default reference-table table-bordered">
          <thead>
            <tr class="center-block">
              <th style="min-width: 25px;">行</th>
              <th style="min-width: 200px;">医療機関名</th>
              <th style="min-width: 70px;">診療</th>
              <th style="min-width: 70px;">電気</th>
              <th style="min-width: 70px;">水道</th>
              <th style="min-width: 70px;">電話</th>
              <th style="min-width: 150px;">院長名</th>
              <th style="min-width: 200px;">住所</th>
            </tr>
          </thead>

          <tbody *ngFor="let syllabaryId of getSyllabaryIds()">
            <tr *ngFor="let clinicStatus of getClinicStatusList(syllabaryId); let i = index">
              <td class="vertical-middle center-block" [attr.rowspan]="getClinicStatusList(syllabaryId).length" *ngIf="i == 0">{{clinicStatus.syllabaryDisplayName}}</td>
              <td class="vertical-middle">
                <span class="update-time-text">{{clinicStatus.updateTime | date:"MM月dd日 HH時更新"}}</span><br *ngIf="clinicStatus.updateTime !== null" />
                <a *ngIf="clinicStatus.consultation !== 2" routerLink="/clinicstatus/{{clinicStatus.institutionId}}"><span [innerHTML]="clinicStatus.institutionName.split('CRLF').join('<br />')"></span></a>
                <a *ngIf="clinicStatus.consultation === 2" routerLink="/clinicstatusedit/{{clinicStatus.institutionId}}"><span [innerHTML]="clinicStatus.institutionName.split('CRLF').join('<br />')"></span></a>
              </td>
              <td class="vertical-middle center-block symbol">{{clinicStatus.consultation == 0 ? '✕'  : clinicStatus.consultation == 1 ? '○': '－'}}</td>
              <td class="vertical-middle center-block symbol">{{clinicStatus.electricity == 0 ? '✕' : clinicStatus.electricity == 1 ? '○' : '－'}}</td>
              <td class="vertical-middle center-block symbol">{{clinicStatus.waterSupply == 0 ? '✕' : clinicStatus.waterSupply == 1 ? '○' : '－'}}</td>
              <td class="vertical-middle center-block symbol">{{clinicStatus.phone == 0 ? '✕' : clinicStatus.phone == 1 ? '○' : '－'}}</td>
              <td class="vertical-middle">{{clinicStatus.directorName}}</td>
              <td class="vertical-middle">{{clinicStatus.address}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
